import { Component, OnInit, ViewChild } from '@angular/core';
import { Mail } from './mail';
import { MailService } from './mail.service';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { Role } from '../role/role';
import { RoleService } from '../role/role.service';
import { Status } from '../status/status';
import { StatusService } from '../status/status.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
    templateUrl: './mail.component.html'
})

export class MailComponent implements OnInit {

    @ViewChild('myTable') myTable;

    items: Mail[] = [];
    item: Mail = new Mail();
    outItem: Mail;
    selectedItem: Mail;
    msgs: Message[] = [];

    rolelist: Role[] = [];
    statuslist: Status[] = [];

    emailForm: FormGroup;

    constructor(
        private activatedRoute: ActivatedRoute,
        private service: MailService,
        private roleService: RoleService,
        private statusService: StatusService,
    ) { }

    ngOnInit() {
        this.emailForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
        });  

        this.statusService.findAll().subscribe(status => {
            this.statuslist = status.filter(x => x.type == "Master");
        });

        this.roleService.findAll().subscribe(roles => {
            this.rolelist = roles.filter(x => x.status.id == 1);
            this.rolelist.forEach(role => {
                role['mails'] = null;
            });
        })

        this.activatedRoute.params.subscribe(params => {
            this.items = this.activatedRoute.snapshot.data['items'];
        });
    }

    newItem() {
        this.msgs = [];
        this.selectedItem = new Mail();
        this.items = [this.selectedItem].concat(this.items);
        this.myTable.first = 0;
    }

    delete(item: Mail) {
        this.msgs = [];
        if (item.id != null){
           this.service.delete(item).subscribe( (data) => {
            const deletedItem = this.items.find(x => x.id === item.id);
            this.items.splice(this.items.indexOf(deletedItem), 1);
            this.msgs.push({
                severity: 'success',
                detail: 'Registro excluído'
            });
           }, (err) => {
            this.msgs.push({
                severity: 'error',
                detail: 'Não é possível excluir o registro'
            });
           });
        }
    }

    save(item: Mail) {
        this.msgs = [];
        if (item.dealerNumber == null)  this.msgs.push({severity:'error', detail:'Número de concessionária obrigatório'});
        if (item.role == null)          this.msgs.push({severity:'error', detail:'Perfil obrigatório'});
        if (item.status == null)        this.msgs.push({severity:'error', detail:'Status obrigatório'});
        if (item.address == null)       this.msgs.push({severity:'error', detail:'Endereço de email obrigatório'});
        else if (this.emailForm.get('email').invalid) this.msgs.push({severity:'error', detail:'Endereço de email inválido'});
        
        if (this.msgs.length > 0)
            return;

        if (item.id == null){
            this.service.save(item).subscribe( params => {
                item.id = params.id;

                this.msgs.push({
                    severity: 'success',
                    detail: 'Registro incluído'
                });
            });
        } else {
            this.service.update(item).subscribe((data) => {
                this.msgs.push({
                    severity: 'success',
                    detail: 'Registro modificado'
                });
            });
        }
        this.selectedItem = null;
    }

    cancel(item : Mail) {
        this.msgs = [];
        if (this.selectedItem.id == null) {
            this.items.shift();
        }

        if(this.outItem != null && this.outItem.id != null){
            item.id = this.outItem.id;
            item.role = this.outItem.role;
            item.address = this.outItem.address;
            item.dealerNumber = this.outItem.dealerNumber;
            item.status = this.outItem.status;
        }

        this.selectedItem = null;
        this.outItem = null;
    }

    edit(item: Mail) {
        this.msgs = [];
        this.selectedItem = item;
        this.outItem = this.clone(item);
    }

    clone(i: Mail): Mail{
        let item = new Mail();
        for(let prop in i){
            item[prop] = i[prop];
        }
        return item;
    }

}